"use client";
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const areAnyButtonsFullWidth = (buttons) => {
  let includesFullWidth = false;
  buttons.map((button) => {
    if (button.props && button.props.width === "full") {
      includesFullWidth = true;
    }
  });
  return includesFullWidth;
};
const ButtonRowSide = (side, buttons, testSection) => {
  const includesFullWidthButton = areAnyButtonsFullWidth(buttons);
  const wrapperClassNames = classNames({
    [`oui-button-row--${side}`]: side,
    flex: includesFullWidthButton,
    "flex--1": true
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: wrapperClassNames,
      "data-oui-component": true,
      "data-test-section": testSection ? testSection + "-" + side : null,
      children: buttons.map((button, index) => {
        if (includesFullWidthButton) {
          const containerClasses = classNames({
            "flex--1": true,
            "push-half--left": index !== 0,
            "push-half--right": index !== buttons.length - 1
          });
          return /* @__PURE__ */ jsx("div", { className: containerClasses, children: button }, index);
        }
        return button;
      })
    }
  );
};
const ButtonRow = ({
  centerGroup,
  className,
  leftGroup,
  rightGroup,
  testSection,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames("oui-button-row flex", className),
      "data-oui-component": true,
      "data-test-section": testSection,
      ...props,
      children: [
        leftGroup ? ButtonRowSide("left", leftGroup, testSection) : null,
        centerGroup ? ButtonRowSide("center", centerGroup, testSection) : null,
        rightGroup ? ButtonRowSide("right", rightGroup, testSection) : null
      ]
    }
  );
};
ButtonRow.propTypes = {
  /** Array of buttons for the center */
  centerGroup: PropTypes.arrayOf(PropTypes.element),
  /** CSS class names. */
  className: PropTypes.string,
  /** Array of buttons for left side */
  leftGroup: PropTypes.arrayOf(PropTypes.element),
  /** Array of buttons for right side */
  rightGroup: PropTypes.arrayOf(PropTypes.element),
  /** Hook for automated JavaScript tests */
  testSection: PropTypes.string
};

export { ButtonRow as default };
